import React from "react";

const PersonalPg = ({ showPersonalData }) => {
  const leftarrow = "/images/mo/leftarrow.svg";
  return (
    <div className="z-20 fixed top-0 left-0 w-full h-full bg-[#F1F2F3]">
      <div className="fixed top-0 left-0 w-full border-b-[1px] flex justify-between items-center px-[8px] bg-[#FAFCFF]">
        <img
          className="inline-block cursor-pointer "
          src={leftarrow}
          alt="leftarrow"
          onClick={showPersonalData}
        />
        <span className="inline-block">서비스</span>
        <span className="inline-block w-[48px] h-[48px]"></span>
      </div>
      <div className="max-w-md mx-auto p-[16px] mt-[48px] h-full overflow-y-auto relative wordbreak-keepall">
        <div className="bg-[#FAFCFF] rounded-lg p-[16px] caption_1_400 ">
          <span className="block">
            장루관리 개인정보 처리방침_일반회원(앱), 병원회원(웹) 공용 주식회사
            헤링스(이하 “회사”라 합니다)는 정보통신망 이용촉진 및 정보보호 등에
            관한 법률(이하 “정보통신망법”), 개인정보보호법, 통신비밀보호법,
            전기통신사업법 등 정보통신서비스제공자가 준수하여야 할 관련 법령상의
            개인정보보호 규정을 준수하며, 관련 법령에 의거한 개인정보처리방침을
            정하여 이용자 권익 보호에 최선을 다하고 있습니다. 본
            개인정보처리방침은 회사가 제공하는 장루관리 앱/웹 (이하
            “서비스”)이용에 적용되며 다음과 같은 내용을 담고 있습니다.
          </span>
          <span className="block caption_1_600 pt-[16px] pb-[8px]">
            [개인정보의 수집 항목 및 이용목적]
          </span>
          <span className="block">
            회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는
            개인정보는 다음 목적 이외의 용도로는 이용되지 않으며, 이용 목적이
            변경되는 경우에는 별도의 동의를 받는 등 필요한 조치를 이행할
            예정입니다.
          </span>
          <span className="block pt-[8px]">
            1. 회사는 서비스 제공을 위하여 수집한 개인정보를 아래의 목적으로
            이용합니다.
          </span>
          <div>
            <span className="block">
              - 회원식별 및 가입의사 확인, 본인∙연령확인, 부정이용 방지 -
              신규서비스 개발, 다양한 서비스 제공, 문의사항 또는 불만∙분쟁처리,
              공지사항 전달
            </span>
            <span className="block">
              - 이벤트 행사 시 정보 전달, 마케팅 및 광고 등에 활용
            </span>
            <span className="block">
              - 서비스 이용 기록, 접속 빈도 및 서비스 이용에 대한 통계, 맞춤형
              서비스 제공, 서비스 개선에 활용
            </span>
            <span className="block">
              - 부정 이용 행위를 포함하여 서비스의 원활한 운영에 지장을 주는
              행위에 대한 방지 및 제재, 계정도용 및 부정거래 방지
            </span>
          </div>
          <span className="block pt-[8px]">
            2. 회사가 처리하는 이용자의 개인정보는 다음과 같습니다.
          </span>
          <div className="text-center break-all border">
            <div className="flex border-b">
              <div className="w-1/5 border-r">구분</div>
              <div className="w-3/5 border-r">처리항목</div>
              <div className="w-2/5">처리목적</div>
            </div>
            <div className="flex border-b ">
              <div className="flex flex-col w-1/5 border-r">
                <div className="border-b h-[60px] flex items-center ">
                  이메일로 가입(개인)
                </div>
                <div className="border-b h-[60px] flex items-center">
                  카카오 계정으로 가입(개인)
                </div>
                <div className="border-b h-[60px] flex items-center">
                  페이스북 계정으로 가입(개인)
                </div>
                <div className="border-b h-[60px] flex items-center">
                  구글 계정으로 가입(개인)
                </div>
                <div className="h-[60px] flex items-center">
                  애플 계정으로 가입(개인)
                </div>
              </div>
              <div className="w-3/5 border-r">
                <div className="border-b h-[60px] flex items-center justify-center">
                  (필수)이름, 이메일, 비밀번호
                </div>
                <div className="border-b h-[60px] flex items-center justify-center">
                  (필수)카카오 연동 ID, 페이스북 토큰, 성명, 프로필 사진
                </div>
                <div className="border-b h-[60px] flex items-center justify-center">
                  (필수)카카오 연동 ID, 페이스북 토큰, 성명, 프로필 사진
                </div>
                <div className="border-b h-[60px] flex items-center justify-center">
                  (필수)구글 연동ID, 구글 토큰
                </div>
                <div className=" h-[60px] flex items-center justify-center">
                  (필수) 성명, 이메일, 애플 연동ID
                </div>
              </div>
              <div className="flex items-center justify-center w-2/5">
                회원 가입의사 확인, 식별∙인증, 회원자격 유지∙관리, 본인확인,
                서비스 부정이용 확인 및 방지, 각종 고지∙통지, 고충처리, 서비스
                제공 및 상담, 만 14세 이상 확인, 만족도 조사
              </div>
            </div>
            <div className="flex border-b ">
              <div className="flex items-center justify-center w-1/5 border-r">
                회원가입(병원회원)
              </div>
              <div className="flex items-center justify-center w-3/5 border-r">
                성명, 휴대전화번호, 대표전화번호, 이메일, 비밀번호, 의료인
                정보(병원명, 병원 전화번호, 사업자등록번호, 요양기관번호, 주소,
                대표자명)
              </div>
              <div className="flex items-center justify-center w-2/5">
                회원 가입의사 확인, 식별∙인증, 회원자격 유지∙관리, 본인확인,
                서비스 부정이용 확인 및 방지, 각종 고지∙통지, 고충처리, 서비스
                제공 및 상담, 만 14세 이상 확인, 만족도 조사
              </div>
            </div>
            <div className="flex border-b ">
              <div className="flex items-center justify-center w-1/5 border-r">
                비대면 진료 및 건강관리 서비스
              </div>
              <div className="flex items-center justify-center w-3/5 border-r">
                이름, 주민등록번호, 휴대폰번호, 자녀이름, 자녀 주민등록번호,
                사전문진 정보, 증상사진 등 참고자료, 내외국인 여부,
                개인위치정보(경도, 위도), 처방전 등 진료 후 정보
              </div>
              <div className="flex items-center justify-center w-2/5">
                비대면진료, 건강상담, 건강관리 등 제반 서비스 이용 시 본인 인증
                및 의료인/의료기관에 정보 제공
              </div>
            </div>
            <div className="flex border-b ">
              <div className="flex items-center justify-center w-1/5 border-r">
                나의 건강정보
              </div>
              <div className="flex items-center justify-center w-3/5 border-r">
                생년월일, 성별, 사전문진정보
              </div>
              <div className="flex items-center justify-center w-2/5">
                비대면진료, 건강상담, 건강관리 등 제반 서비스 이용 시 본인 인증
                및 의료인/의료기관에 정보 제공
              </div>
            </div>
            <div className="flex border-b ">
              <div className="flex items-center justify-center w-1/5 border-r">
                서비스 이용 시 자동 생성되는 정보
              </div>
              <div className="flex items-center justify-center w-3/5 border-r">
                서비스 이용 기록, 접속 로그, 쿠키, 접속IP 주소,
                기기고유번호(등록번호, 디바이스 아이디 또는 IMEI), 불량 이용
                기록, 광고식별자, 사용 이동통신사
              </div>
              <div className="flex items-center justify-center w-2/5">
                서비스/상품 이용 정보 통계 및 분석
              </div>
            </div>
            <div className="flex border-b ">
              <div className="flex items-center justify-center w-1/5 border-r">
                병원/약국 찾기 서비스 이용 시
              </div>
              <div className="flex items-center justify-center w-3/5 border-r">
                개인위치정보(경도, 위도)
              </div>
              <div className="flex items-center justify-center w-2/5">
                병원찾기 서비스 제공
              </div>
            </div>
            <div className="flex border-b ">
              <div className="flex items-center justify-center w-1/5 border-r">
                이벤트 응모 및 상담신청
              </div>
              <div className="flex items-center justify-center w-3/5 border-r">
                (필수) 이름, 휴대전화번호 (선택) 성별, 생년월일
              </div>
              <div className="flex items-center justify-center w-2/5">
                이벤트 및 혜택 알림 정보 등 마케팅 ∙ 광고 활용,
                서비스/신상품이나 이벤트 정보 안내, 이벤트 경품 배송
              </div>
            </div>
            <div className="flex border-b ">
              <div className="flex items-center justify-center w-1/5 border-r">
                재외국민 비대면진료 서비스
              </div>
              <div className="flex items-center justify-center w-3/5 border-r">
                여권번호, 휴대폰번호
              </div>
              <div className="flex items-center justify-center w-2/5">
                재외국민 본인 인증
              </div>
            </div>
          </div>
          <span className="block caption_1_600 pt-[16px] pb-[8px]">
            [개인정보의 처리 및 보유 기간]
          </span>
          <span className="block pt-[4px]">
            1. 이용자의 개인정보는 그 수집목적 또는 제공받은 목적이 달성되거나
            이용계약 해지(회원탈퇴)를 요청한 경우 파기하는 것을 원칙으로 하며,
            이 경우 이용자의 개인정보는 재생할 수 없는 방법에 의하여 시스템에서
            완전히 삭제되며 어떠한 용도로도 열람 또는 이용할 수 없도록
            처리됩니다. 또한, 일시적인 목적(설문조사 등)으로 입력 받은
            개인정보는 그 목적이 달성된 이후에는 동일한 방법으로 사후 재생이
            불가능한 방법으로 처리됩니다.
          </span>
          <span className="block pt-[4px]">
            2. 회사는 불량 회원의 부정한 이용의 재발을 방지하기 위해 이용계약
            해지일(회원탈퇴일)로부터 1년간 해당 회원의 개인정보를 보유할 수
            있습니다. 그리고 상법 등 관계법령의 규정에 의하여 보존할 필요가 있는
            경우 회사는 관계법령에서 정한 일정한 기간 동안 회원정보를
            보관합니다. 이 경우 회사는 보관하는 정보를 그 보관의 목적으로만
            이용하며 보존기간은 아래와 같습니다.
          </span>
          <span className="block caption_1_600 pt-[16px] pb-[8px]">
            ※ 회사 내부 정책에 의하여 수집 및 이용되는 정보
          </span>
          <div className="text-center border">
            <div className="flex border-b">
              <div className="w-1/3 border-r">구분</div>
              <div className="w-1/3 border-r">항목</div>
              <div className="w-1/3 border-r">기간</div>
            </div>
            <div className="flex">
              <div className="flex items-center justify-center w-1/3 border-r">
                회사 내부 정책 (부정거래의 배제 등 회사 방침에 의한 보존)
              </div>
              <div className="flex items-center justify-center w-1/3 border-r">
                아이디, DI (Duplication Information)
              </div>
              <div className="flex items-center justify-center w-1/3 border-r">
                회원탈퇴 후 1년
              </div>
            </div>
          </div>
          <span className="block caption_1_600 pt-[16px] pb-[8px]">
            ※ 법령에 의하여 수집 및 이용되는 정보
          </span>
          <div className="text-center border">
            <div className="flex border-b">
              <div className="w-1/3 border-r">근거법령</div>
              <div className="w-1/3 border-r">보존항목</div>
              <div className="w-1/3 border-r">보존기간</div>
            </div>
            <div className="flex border-b">
              <div className="flex items-center justify-center w-1/3 border-r">
                신용정보의 이용 및 보호에 관한 법률
              </div>
              <div className="flex items-center justify-center w-1/3 border-r">
                신용정보의 수집/처리 및 이용 등에 관한 기록
              </div>
              <div className="flex items-center justify-center w-1/3 border-r">
                3년
              </div>
            </div>
            <div className="flex">
              <div className="flex items-center justify-center w-1/3 border-r">
                통신비밀보호법
              </div>
              <div className="flex items-center justify-center w-1/3 border-r">
                서비스 방문 기록
              </div>
              <div className="flex items-center justify-center w-1/3 border-r">
                3개월
              </div>
            </div>
          </div>
          <span className="block pt-[8px]">
            3. 이용약관 및 관계법령을 위반한 회원의 경우 다른 회원을 보호하고
            사법기관 수사의뢰 시 증거자료로 활용하기 위해 회원탈퇴 후 2년 까지
            회원정보를 보관할 수 있습니다.
          </span>
          <span className="block pt-[4px]">
            4. 2022년 05월 06일 이후 가입한 회원이 1년간 서비스 거래기록이 없을
            시, “정보통신망법” 제29조에 근거하여 회원에게 사전통지하고
            개인정보를 파기하거나 별도로 분리하여 저장 관리합니다. 고객의 요청이
            있을 경우에는 위 기간을 달리 정할 수 있습니다. 단, 통신비밀보호법
            등의 관계법령의 규정에 의하여 보존할 필요가 있는 경우 관계법령에서
            규정한 일정한 기간 동안 회원 개인정보를 보관합니다. 회사는 위의
            1년의 기간 만료 30일 전까지 개인정보가 파기되거나 분리되어
            저장∙관리되는 사실과 기간 만료일 및 해당 개인정보의 항목을 전자우편
            등의 방법으로 고객에게 알립니다. 이를 위해 고객은 정확한 연락처
            정보를 제공/수정하여야 합니다.
          </span>
          <span className="block caption_1_600 pt-[16px] pb-[8px]">
            [개인정보의 제3자에 대한 제공]
          </span>
          <span className="block pt-[4px]">
            1. 회사는 이용자들의 개인정보를 "개인정보의 수집 항목 및
            이용목적"에서 고지한 범위 내에서 사용하며, 이용자의 사전 동의 없이는
            동 범위를 초과하여 이용하거나 원칙적으로 이용자의 개인정보를 외부에
            공개하지 않습니다. 다만 다음의 경우에는 이용자의 개인정보를
            제3자에게 제공(공유를 포함)할 수 있습니다.
          </span>
          <div>
            <span className="block">
              - 이용자가 개인정보의 수집 및 이용에 대한 동의와 별도로 제3자
              제공에 사전 동의한 경우: 회사는 이용자에게 개인정보를 제공받는
              자의 성명과 연락처, 제공받는 자의 개인정보 이용 목적, 제공하는
              개인정보의 항목, 제공받는 자의 개인정보 보유 및 이용 기간, 동의
              거부권이 존재한다는 사실 및 동의 거부에 따른 불이익의 내용을 미리
              알립니다.
            </span>
            <span className="block">
              - 법률규정이 있거나 법령상 의무준수를 위해 불가피한 경우
            </span>
            <span className="block">
              - 수사기관이 수사목적을 위해 관계법령이 정한 절차를 거쳐 요구하는
              경우
            </span>
            <span className="block">
              - 통계작성 및 학술연구 등의 목적을 위해 필요한 경우로서 특정 개인
              또는 회원을 알아볼 수 없는 형태로 개인정보를 제공하는 경우
            </span>

            <div className="border text-center mt-[8px]">
              <div className="flex border-b">
                <div className="w-1/3 border-r">제공 받는자</div>
                <div className="w-1/3 border-r">제공 목적</div>
                <div className="w-1/3 border-r">제공 정보</div>
              </div>
              <div className="flex border-b">
                <div className="flex items-center justify-center w-1/3 border-r">
                  병원회원
                </div>
                <div className="flex items-center justify-center w-1/3 border-r">
                  비대면 진료 및 건강관리 서비스 제공
                </div>
                <div className="flex items-center justify-center w-1/3 border-r">
                  이름, 주민등록번호, 휴대폰번호, 자녀이름, 자녀 주민등록번호,
                  사전문진 정보, 증상사진 등 참고자료, 내외국인 여부,
                  개인위치정보(경도, 위도), 처방전 등 진료 후 정보
                </div>
              </div>
            </div>
          </div>
          <span className="block caption_1_600 pt-[16px] pb-[8px]">
            [개인정보 처리의 위탁]
          </span>
          <span className="block pt-[4px]">
            1. 회사는 향상된 서비스를 제공하기 위해 개인정보 처리를 위탁하여
            처리할 수 있습니다. 위탁업무를 하는 경우에는 다음의 내용을
            이용자에게 알리고 동의를 받으며, 어느 하나의 사항이 변경된 경우에도
            동일합니다. 보다 나은 서비스 제공을 위해 국내에 위탁한 개인정보
            수탁업체는 다음과 같습니다 .
          </span>
          <div className="border text-center mt-[8px]">
            <div className="flex border-b">
              <div className="w-1/4 border-r">수탁업체</div>
              <div className="w-1/4 border-r">위탁업무</div>
              <div className="w-1/4 border-r">위탁정보</div>
              <div className="w-1/4 border-r">보유기간</div>
            </div>
            <div className="flex border-b">
              <div className="flex items-center justify-center w-1/4 border-r">
                헤링스
              </div>
              <div className="flex items-center justify-center w-1/4 border-r">
                휴대폰 본인 확인
              </div>
              <div className="flex items-center justify-center w-1/4 border-r">
                이름, 생년월일, 통신사, 성별, 휴대폰번호
              </div>
              <div className="flex items-center justify-center w-1/4 border-r">
                이용 목적 달성 시까지
              </div>
            </div>
          </div>
          <span className="block pt-[4px]">
            2. 회사는 서비스 제공의 안정성과 최신 기술을 이용자에게 제공하기
            위해 개인정보를 위탁하고 있으며, 이용자로부터 취득 또는 생성한
            개인정보를 AWS (Amazon Web Services Inc.)가 보유하고 있는
            데이터베이스(물리적 저장 장소: 한국)에 저장합니다. AWS는 해당 서버의
            물리적인 관리만을 행하고, 이용자의 개인정보에 접근할 수 없습니다.
          </span>
          <div className="border text-center mt-[8px]">
            <div className="flex border-b">
              <div className="flex items-center justify-center w-1/5 border-r">
                수탁업체
              </div>
              <div className="flex items-center justify-center w-1/5 border-r">
                위탁업무
              </div>
              <div className="flex items-center justify-center w-1/5 border-r">
                이전국가
              </div>
              <div className="flex items-center justify-center w-1/5 border-r">
                이전 일시 및 방법
              </div>
              <div className="flex items-center justify-center w-1/5 border-r">
                보유기간
              </div>
            </div>
            <div className="flex border-b">
              <div className="flex items-center justify-center w-1/5 border-r">
                AWS
              </div>
              <div className="flex items-center justify-center w-1/5 border-r">
                서비스 이용 기록 또는 수집된 개인정보
              </div>
              <div className="flex items-center justify-center w-1/5 border-r">
                한국
              </div>
              <div className="flex items-center justify-center w-1/5 border-r">
                서비스 이용 시점에 네트워크를 통한 전송
              </div>
              <div className="flex items-center justify-center w-1/5 border-r">
                클라우드 서비스 이용 변경 시까지
              </div>
            </div>
          </div>
          <span className="pt-[4px] block">
            3. 회사는 위탁계약 체결 시 위탁업무 수행목적 외 개인정보 처리금지,
            기술적∙관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리∙감독,
            손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가
            개인정보를 안전하게 처리하는 지를 감독하고 있습니다. 위탁업무의
            내용이나 수탁자가 변경될 경우에는 지체 없이 본 개인정보 처리방침을
            통하여 공개합니다.
          </span>
          <span className="block caption_1_600 pt-[16px] pb-[8px]">
            [개인정보주체의 권리와 의무 및 그 행사방법]
          </span>
          <span className="pt-[4px] block">
            1. 이용자는 언제든지 회사 서비스 상에 등록되어 있는 자신의 개인정보,
            회사가 이용자의 개인정보를 이용하거나 제3자에게 제공한 현황,
            회사에게 개인정보 수집, 이용, 제공 등의 동의를 한 현황에 대하여
            열람이나 제공을 요구할 수 있고, 오류가 있는 경우에는 그 정정을
            요구할 수 있으며, 삭제 내지 가입해지를 요구할 수도 있습니다.
          </span>
          <span className="pt-[4px] block">
            2. 이용자 혹은 만 14세 미만 아동의 개인정보 조회, 수정을 위해서는
            ‘개인정보변경’(또는 ‘이용자정보수정’ 등)을, 가입해지(동의철회)를
            위해서는 “이용자탈퇴”를 클릭하여 본인 확인 절차를 거치신 후 직접
            열람, 정정 또는 탈퇴가 가능합니다.
          </span>
          <span className="pt-[4px] block">
            3. 이 경우에 회사는 지체 없이 그 개인정보를 조사하여 이용자의 요구에
            따라 정정, 삭제 등 필요한 조치를 한 후 그 결과를 이용자에게
            알립니다. 회사는 필요한 조치를 할 때까지는 해당 개인정보를
            이용하거나 제공하지 않습니다.
          </span>
          <span className="pt-[4px] block">
            4. 이용자는 언제든지 회사에 자신의 개인정보 처리의 정지를 요구할 수
            있으며, 이 경우에 회사는 지체 없이 그 요구에 따라 개인정보 처리의
            전부 내지 일부를 정지하며, 처리가 정지된 개인정보에 대하여 지체 없이
            그 개인정보의 파기 등 필요한 조치를 취합니다.
          </span>
          <span className="block caption_1_600 pt-[16px] pb-[8px]">
            [개인정보 파기절차 및 방법]
          </span>
          <span className="pt-[4px] block">
            회사는 개인정보 보유기간의 경과, 개인정보의 수집 및 이용목적 달성 등
            그 개인정보가 불필요하게 되었을 때에는 지체 없이 파기합니다. 회사의
            개인정보 파기절차 및 방법은 다음과 같습니다.
          </span>
          <span className="pt-[4px] block">
            1. 파기절차 회사는 개인정보의 파기에 관한 사항을 기록하고 관리하며,
            파기는 개인정보 보호책임자의 책임하에 수행되며, 개인정보
            보호책임자는 파기 결과를 확인합니다. 회사는 다른 법령에 따라
            보존해야 하는 경우에는 예외적으로 이용자의 개인정보를 파기하지 않을
            수 있습니다.
          </span>
          <span className="pt-[4px] block">
            2. 파기방법 종이나 그 밖의 기록매체에 저장된 개인정보는 파쇄하거나
            소각합니다. 전자적 파일 형태로 저장된 개인정보는 복원이 불가능한
            방법(또는 기록을 재생할 수 없는 기술적 방법)으로 영구 삭제합니다.
          </span>
          <span className="pt-[4px] block">
            3. 미파기 정보의 보존방법 회사는 법령에 따라 개인정보를 파기하지
            않고 보존하는 경우에 해당 개인정보 또는 개인정보파일을 다른
            개인정보와 분리하여 저장 관리합니다. 회사는 별도 DB로 옮긴
            개인정보를 법률에 의한 경우가 아니고서는 보유하는 이외의 다른
            목적으로 이용하지 않습니다.
          </span>
          <span className="block caption_1_600 pt-[16px] pb-[8px]">
            [개인정보 보호책임자 및 담당부서]
          </span>
          <span className="pt-[4px] block">
            회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보
            처리와 관련한 이용자의 불만처리 및 피해구제 등을 위하여 아래와 같이
            개인정보 보호책임자 및 담당부서를 지정하고 있습니다. 이용자는 회사의
            서비스를 이용하면서 발생한 모든 개인정보보호 관련 문의, 불만처리,
            피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실
            수 있습니다. 회사는 이용자의 문의에 대해 지체 없이 답변 및
            처리합니다.
          </span>
          <span className="block caption_1_600 pt-[16px] pb-[8px]">
            [개인정보 보호 책임자]
          </span>
          <p className="pt-[4px]">
            <p className="block">- 개인정보 보호책임자: 탁틴</p>
            <br />
            <p className="block">- 담당부서/직위: Product Team/차장</p>
            <p className="block">- 이메일 주소: product@heringsglobal.com</p>
          </p>
          <span className="block caption_1_600 pt-[16px] pb-[8px]">
            [개인정보 처리방침의 변경]
          </span>
          <p className="pt-[4px]">
            회사는 개인정보처리방침에 대한 변경이 있을 경우에는 개정
            개인정보처리방침의 시행일로부터 최소 7일 전에 서비스(장루관리
            앱/웹)의 공지사항 또는 이메일을 통해 고지합니다. 또한, 필요 시
            이용자 동의를 다시 받을 수도 있습니다.
          </p>
          <span className="block caption_1_600 pt-[16px] pb-[8px]">
            [개인정보의 안전성 확보조치]
          </span>
          <p className="pt-[4px]">
            회사는 이용자들의 개인정보를 취급함에 있어 개인정보가 분실, 도난,
            유출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은
            기술적 대책을 강구하고 있습니다.
          </p>
          <span className="block pt-[4px]">
            1. 이용자의 개인정보는 비밀번호에 의해 보호되며 파일 및 전송데이터를
            암호화하거나 파일 잠금기능(Lock)을 사용하여 중요한 데이터는 별도의
            보안기능을 통해 보호되고 있습니다.
          </span>
          <span className="block pt-[4px]">
            2. 회사는 백신프로그램을 이용하여 컴퓨터바이러스에 의한 피해를
            방지하기 위한 조치를 취하고 있습니다. 백신프로그램은 주기적으로
            업데이트되며 갑작스런 바이러스가 출현할 경우 백신이 나오는 즉시 이를
            제공함으로써 개인정보가 침해되는 것을 방지하고 있습니다.
          </span>
          <span className="block pt-[4px]">
            3. 해킹 등 외부침입에 대비하여 각 서버마다 침입차단시스템 및 취약점
            분석시스템 등을 이용하여 보안에 만전을 기하고 있습니다.
          </span>
          <span className="block pt-[4px]">
            4. 회사는 이용자의 개인정보에 대한 접근권한을 최소한의 인원으로
            제한하고 있으며 이용자를 직접 상대로 하여 마케팅 업무를 수행하는 자,
            개인정보 보호책임자 및 담당자 등 개인정보관리업무를 수행하는 자,
            기타 업무상 개인정보의 취급이 불가피한 자 외에는 접근을 엄격히
            제한하고 담당직원에 대한 수시 교육을 통하여 본 정책의 준수를
            강조하고 있습니다.
          </span>
          <span className="block caption_1_600 pt-[16px] pb-[8px]">
            [개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항]
          </span>
          <p className="pt-[4px]">
            회사는 이용자들에게 특화된 맞춤서비스를 제공하기 위해서 이용자들의
            정보를 저장하고 수시로 불러오는 ’쿠키(cookie)’를 사용합니다. 쿠키는
            웹사이트를 운영하는데 이용되는 서버(HTTP)가 이용자의 컴퓨터
            브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터 내의
            하드디스크에 저장되기도 합니다.
          </p>
          <span className="block pt-[4px]">
            1. 쿠키의 사용 목적: 회사의 서비스와 웹 사이트들에 대한 이용자들의
            방문 및 이용형태, 인기 검색어, 보안접속 여부, 이용자 규모 등을
            파악하여 이용자에게 최적화된 정보 제공을 위하여 사용합니다.
          </span>
          <span className="block pt-[4px]">2. 쿠키의 설치/운영 및 거부:</span>
          <span className="block pt-[4px]">
            1) 이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서,
            이용자는 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나,
            쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을
            거부할 수도 있습니다. 단, 쿠키의 저장을 거부할 경우에는 로그인이
            필요한 일부 서비스는 이용에 어려움이 있을 수 있습니다.
          </span>
          <span className="block">
            2) 쿠키 설정을 거부하는 방법으로는 이용자가 사용하는 웹 브라우저의
            옵션을 선택함으로써 모든 쿠키를 허용하거나 쿠키를 저장할 때마다
            확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다.
          </span>
          <span className="block pt-[16px]">
            부 칙 1. 본 방침은 2022년 05월 06일부터 적용됩니다.
          </span>
        </div>
        <div className="bg-[#F1F2F3] h-[48px]"></div>
      </div>
    </div>
  );
};

export default PersonalPg;
